import { isEmpty } from 'lodash';

export const attendButtonIsVisible = (event, settings) => {
  const ticketSpotButtonDisplay = event.get('type') === 'eventviewer' && (!isEmpty(event.get('url')) || event.get('use_checkout_form'));
  const integrationButtonDisplay = event.get('type') !== 'eventviewer' && !isEmpty(event.get('url'));
  return !settings.get('removeAttendButton') && (integrationButtonDisplay || ticketSpotButtonDisplay);
};
